import { useEffect, useState } from 'react';
import { LoadTender } from '@api/Trinium/Endpoints/EDI/types';
import { CircularProgress } from '@mui/material';
import { GRID_CHECKBOX_SELECTION_COL_DEF, GridRenderCellParams } from '@mui/x-data-grid-pro';
import { useAppSelector } from '@reduxStore';

enum CellState {
	Default,
	Loading
}

export default function EdiRowSelectCheckbox(props: GridRenderCellParams<LoadTender>) {
	const [cellState, setCellState] = useState(CellState.Default);
	const { id } = props.row;
	const { loadingSet } = useAppSelector((state) => state.ediLoadTenderState);

	useEffect(() => {
		if (loadingSet.includes(id)) {
			setCellState(CellState.Loading);
		} else {
			setCellState(CellState.Default);
		}
	}, [loadingSet, id]);

	switch (cellState) {
		case CellState.Loading:
			return <CircularProgress size={18} />;
		default:
			return GRID_CHECKBOX_SELECTION_COL_DEF.renderCell ? GRID_CHECKBOX_SELECTION_COL_DEF.renderCell(props) : <></>;
	}
}
